import React__default, { useCallback } from 'react';
import c from 'classnames';
import '@babel/runtime/helpers/extends';
import '@babel/runtime/helpers/objectWithoutPropertiesLoose';
import '@mui/material/Button';
import 'lodash/merge';
import '../../../Buttons/utils/utils.js';
import BaseButton from '../../../Buttons/BaseButton/BaseButton.js';
import '@mui/material/IconButton';
import '../../../Buttons/IconButton/utils.js';
import Typography from '../../../Typography/Typography.js';

var classes = {
  notSelected: 'text-text-primary border-divider bg-bg-secondary hover:bg-bg-tertiary',
  root: 'box-border w-44 h-44 border border-solid cursor-pointer rounded-full',
  selected: 'text-text-white bg-interactive-primary border-interactive-primary hover:bg-interactive-primary'
};
var NumberRatingItem = function NumberRatingItem(props) {
  var className = props.className,
    onChange = props.onChange,
    selected = props.selected,
    value = props.value;
  var onClick = useCallback(function () {
    return onChange(value);
  }, [onChange, value]);
  return /*#__PURE__*/React__default.createElement(BaseButton, {
    className: c('flex flex-row items-center justify-center p-0 min-w-0', classes.root, selected ? classes.selected : classes.notSelected, className),
    onClick: onClick,
    onLayout: props == null ? void 0 : props.onLayout
  }, /*#__PURE__*/React__default.createElement(Typography, {
    color: selected ? 'text-text-white' : 'text-text-primary',
    variant: "body-short-02"
  }, value));
};
var NumberRatingItem$1 = /*#__PURE__*/React__default.memo(NumberRatingItem);

export { NumberRatingItem$1 as default };
//# sourceMappingURL=index.js.map
